import { render, staticRenderFns } from "./RolesPage.vue?vue&type=template&id=6c093be8"
import script from "./RolesPage.vue?vue&type=script&lang=js"
export * from "./RolesPage.vue?vue&type=script&lang=js"
import style0 from "./RolesPage.vue?vue&type=style&index=0&id=6c093be8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports